/**
 * Фильтры в шаблонах.
 */

import Vue from "vue";

Vue.filter("localDateTime", (value) => {
  return !value ? "-" : moment.tz(value, moment.tz.guess()).format("DD.MM.YYYY HH:mm:ss");
});

Vue.filter("localDateTimeZone", (value) => {
  return !value ? "-" : moment.tz(value, moment.tz.guess()).format("DD.MM.YYYY HH:mm:ss (Z)");
});

Vue.filter("localDate", (value) => {
  return !value ? "-" : moment(value).format("DD.MM.YYYY");
});

Vue.filter("localTime", (value) => {
  return !value ? "-" : moment.tz(value, moment.tz.guess()).format("HH:mm:ss");
});

Vue.filter("bool", (value) => {
  return value ? "Да" : "Нет";
});
